const decodeBase64 = (payload) => {
  return decodeURIComponent(
    // Javascript ASCII to binary function
    atob(payload).split("").map((char) => {
      return `%${`00${char.charCodeAt(0).toString(16)}`.slice(-2)}`;
    }).join("")
  );
};
export {
  decodeBase64
};
//# sourceMappingURL=decodeBase64.js.map
